// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_out_of_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Out of Stock`
};

const el_out_of_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Εξαντλήθηκε`
};

const ru_out_of_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Нет в наличии`
};

const he_out_of_stock = /** @type {(inputs: {}) => string} */ () => {
	return `אזל מהמלאי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const out_of_stock = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.out_of_stock(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("out_of_stock", locale)
	if (locale === "en") return en_out_of_stock(inputs)
	if (locale === "el") return el_out_of_stock(inputs)
	if (locale === "ru") return ru_out_of_stock(inputs)
	if (locale === "he") return he_out_of_stock(inputs)
	return "out_of_stock"
};